import { render } from "./PushTable.vue?vue&type=template&id=f1a8452c&scoped=true"
import script from "./PushTable.vue?vue&type=script&lang=js"
export * from "./PushTable.vue?vue&type=script&lang=js"

import "./PushTable.vue?vue&type=style&index=0&id=f1a8452c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1a8452c"]])

export default __exports__